export default __webpack_public_path__ + "static/media/alexandra-fuller-5KXaEUZ3DhU-unsplash.127deddf.jpg";